import { render, staticRenderFns } from "./audioSetting.vue?vue&type=template&id=1830658e&scoped=true"
import script from "./audioSetting.vue?vue&type=script&lang=js"
export * from "./audioSetting.vue?vue&type=script&lang=js"
import style0 from "./audioSetting.vue?vue&type=style&index=0&id=1830658e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1830658e",
  null
  
)

export default component.exports